import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ShieldAlert } from "lucide-react";

// İki adımlı (2 yönlü) onaylı toplu silme diyaloğu — kalıcı silme öncesi çift teyit.
export default function BulkDeleteDialog({ open, count, label = "kayıt", busy, onClose, onConfirm }) {
  const [step, setStep] = useState(1);
  const [ack, setAck] = useState(false);
  useEffect(() => { if (open) { setStep(1); setAck(false); } }, [open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="bulk-delete-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading text-red-600">
            <AlertTriangle className="h-5 w-5" /> Toplu Silme{step === 2 ? " · Son Onay" : ""}
          </DialogTitle>
          <DialogDescription>
            {step === 1
              ? `Seçili ${count} ${label} kalıcı olarak silinecek. Bu işlem geri alınamaz.`
              : `İki adımlı güvenlik onayı — ${count} ${label} SİLİNECEK.`}
          </DialogDescription>
        </DialogHeader>
        {step === 1 ? (
          <div className="space-y-4">
            <div data-testid="bulk-delete-count" className="rounded-md bg-red-50 px-3 py-3 text-sm text-red-700 ring-1 ring-inset ring-red-200">
              <b>{count}</b> {label} seçildi.
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" data-testid="bulk-delete-cancel" onClick={onClose}>Vazgeç</Button>
              <Button data-testid="bulk-delete-next" disabled={!count} onClick={() => setStep(2)} className="bg-red-600 text-white hover:bg-red-700">Devam Et</Button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <label className="flex cursor-pointer items-start gap-2 rounded-md bg-red-50 px-3 py-3 text-sm text-red-700 ring-1 ring-inset ring-red-200">
              <input type="checkbox" data-testid="bulk-delete-ack" checked={ack} onChange={(e) => setAck(e.target.checked)} className="mt-0.5 h-4 w-4 accent-red-600" />
              <span>Evet, <b>{count}</b> {label} kalıcı olarak silinsin. Sonuçları anladım ve onaylıyorum.</span>
            </label>
            <div className="flex justify-between gap-2">
              <Button variant="outline" data-testid="bulk-delete-back" onClick={() => setStep(1)}>Geri</Button>
              <Button data-testid="bulk-delete-confirm" disabled={!ack || busy} onClick={onConfirm} className="bg-red-600 text-white hover:bg-red-700">
                <ShieldAlert className="mr-1.5 h-4 w-4" /> {busy ? "Siliniyor..." : "Kalıcı Olarak Sil"}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
